<template>
    <SettingsLayout>
        <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink
                class="mr-3"
                href="/einstellungen/rollenverwaltung"
                type="close"
                >Zurück</HeaderLink
            >
            <HeaderButton @click="submitForm()">Speichern</HeaderButton>
        </template>
        <Heading title="Neue Rolle hinzufügen" />

        <p class="max-w-2xl text-sm text-oteoText">
            Bitte weisen Sie den Nutzer/innen die Rolle zu, mit denen die
            entsprechenden Berechtigungen für oteo hinterlegt sind. Bei Bedarf
            können Sie neue Rollen hinzufügen und die Berechtigungen anpassen.
        </p>

        <div class="grid grid-cols-2 max-w-3xl gap-y-8 gap-5 mt-8">
            <div class="">
                <Label> Rolle </Label>

                <Input class="w-full" v-model="form.name" type="text" />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.name">
                    {{ errors.name }}
                </div>
            </div>
        </div>
    </SettingsLayout>
</template>

<script setup>
const page_name = "Rollenverwaltung";

const props = defineProps({
    errors: Object,
});
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

function submitForm() {
    saveBtnClicked = true;
    form.post("/roles");
}

const form = useForm({
    name: "",
});

import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { onUnmounted } from "vue";
</script>
